<template>
  <div
    v-show="!billingSkipped"
    id="billing-checkout-display"
    class="billing-display"
  >
    <!-- Credit Card Modal -->
    <CreditModal
      :show="showModal"
      header-class="id-modal !tw-flex-col-reverse"
      :body-class="isOnboardingRedesign ? `id-body-modal tw-mx-auto` : `id-body-modal`"
      :full-width="isOnboardingRedesign ? true : false"
      @exit="hideModal()"
    >
      <template #header>
        <div
          :class="{
            'tw-flex-1 tw-flex tw-justify-center tw-items-center tw-mt-[2rem] md:tw-mt-[3rem]': isOnboardingRedesign,
            'tw-mt-[7rem] md:tw-mt-[5rem]': !isOnboardingRedesign,
          }"
        >
          <img
            v-if="['E1', 'F1', 'F2', 'F3v1', 'F3v2', 'G', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant)"
            :class="{'tw-h-[81px] md:tw-h-[150px]': isOnboardingRedesign}"
            :src="require('@/assets/images/credit-green.svg')"
            alt=""
          >
          <img
            v-else
            :class="{
              'tw-h-[81px] md:tw-h-[150px]': isOnboardingRedesign,

            }"
            :src="require('@/assets/images/credit.svg')"
            alt=""
          >
        </div>
        <b-row
          v-if="!isOnboardingRedesign"
          class="security-row mt-5 pt-3"
        >
          <b-col cols="12">
            <b-icon icon="lock-fill" /> 256-BIT TLS SECURITY
          </b-col>
        </b-row>
      </template>

      <template #body>
        <div 
          :class="{'tw-max-w-[750px] tw-mx-auto': isOnboardingRedesign}"
        >
          <h3
            :class="{'tw-mt-10 tw-text-[#787878] tw-capitalize': isOnboardingRedesign, 'tw-uppercase text-primary sub-text tw-tracking-[0.16em]': !isOnboardingRedesign}"
          >
            Billing Information
          </h3>

          <h2
            class="mt-5 initial-line-height"
            :class="isOnboardingRedesign ? 'tw-mb-6 tw-text-2xl' : 'heading h1 text-default mb-2 '"
          >
            Why do you need my credit card information?
          </h2>
          <template v-if="isOnboardingRedesign">
            <p
              v-if="['E1', 'F3v1', 'F3v2', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant)"
              class="sub-text tw-text-lg"
            >
              Winona's physicians are on-hand to review your medical information
              quickly in order to provide you with safe, accessible care so you can
              feel better right away. We ask that you share your credit card information so that if the
              medication is approved by a doctor, we can process it immediately.
              Your card will never be charged until treatment is prescribed.
            </p>
            <p
              v-else
              class="sub-text tw-text-lg"
            >
              Winona’s physicians are on hand to review your medical information
              quickly in order to provide you with safe, accessible care so you can
              feel better right away. We ask that you share your credit card information so that if the
              medication is approved by one of our doctors we can get it to you
              right away and to ensure that our patients are serious about the
              desire to receive treatment. Your card will never be charged until treatment is prescribed.
            </p>
          </template>
          <template v-else>
            <p class="sub-text">
              Winona’s physicians are on hand to review your medical information
              quickly in order to provide you with safe, accessible care so you can
              feel better right away.
            </p>
            <p class="sub-text">
              We ask that you share your credit card information so that if the
              medication is approved by one of our doctors we can get it to you
              right away and to ensure that our patients are serious about the
              desire to receive treatment.
            </p>
            <p class="sub-text">
              Your card will never be charged until treatment is prescribed.
            </p>
          </template>

          <h2
            class="mt-4 initial-line-height"
            :class="isOnboardingRedesign ? 'tw-mb-6 tw-text-2xl' : 'heading h1 text-default mb-2 '"
          >
            Shouldn’t I talk to a Winona doctor before purchasing treatment?
          </h2>

          <template v-if="isOnboardingRedesign">
            <p
              v-if="['E1', 'F3v1', 'F3v2', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant)"
              class="sub-text tw-text-lg tw-pb-36"
            >
              Your Winona physician will never prescribe a treatment without first
              reviewing your medical history and addressing any questions or
              concerns either of you may have. Once you enter your credit card information, you’ll be directed to
              your secure Patient Portal where you can directly message your doctor.
              If you have any additional questions, you can ask them at this step.
            </p>
            <p
              v-else
              class="sub-text tw-text-lg tw-pb-36"
            >
              Your Winona physician will never prescribe a treatment without first
              reviewing your medical history, and addressing any questions or
              concerns either of you may have. Once you enter your credit card information you will be directed to
              your secure patient portal where you can directly message your doctor.
              If you have any additional questions, you can ask them at this step.
            </p>
          </template>
          <template v-else>
            <p class="sub-text">
              Your Winona physician will never prescribe a treatment without first
              reviewing your medical history, and addressing any questions or
              concerns either of you may have.
            </p>
            <p class="sub-text">
              Once you enter your credit card information you will be directed to
              your secure patient portal where you can directly message your doctor.
              If you have any additional questions, you can ask them at this step.
            </p>
          </template>
          <div class="tw-h-[8rem] tw-w-full">
          </div>
          <div
            :class="isOnboardingRedesign ? 'tw-text-center tw-fixed tw-bg-white tw-bottom-0 tw-left-0 tw-right-0 tw-px-4' : 'tw-text-left'"
            :style="isOnboardingRedesign ? 'box-shadow: -8px -6px 23.3px 0px rgba(45, 43, 43, 0.05);' : ''"
          >
            <b-button
              pill
              block
              variant="info"
              class="slight-rounded"
              :class="isOnboardingRedesign ? 'tw-max-w-[300px] tw-mx-auto tw-my-4' : 'mt-5'"
              @click="hideModal()"
            >
              I understand
            </b-button>
          </div>
        </div>
      </template>
    </CreditModal>
    <div
      class="bg-overlay"
      @click="hideModal()"
    ></div>

    <h2
      v-if="isOnboardingRedesign"
      class="question-title with-subtext tw-mb-8"
    >
      {{ onboardingVariant === 'D1'
        ? 'Your doctor is waiting'
        : 'Please provide your billing information.'
      }}
    </h2>
    <h2
      v-else
      class="question-title with-subtext"
    >
      Your doctor is waiting
    </h2>
    <template v-if="isOnboardingRedesign">
      <p
        v-if="['E1', 'F3v1', 'F3v2', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant)"
        class="tw-text-black tw-mb-4 tw-text-[20px] md:tw-text-2xl"
      >
        Add a payment method to be used if treatment is prescribed (you will not be charged at this time).
      </p>
      <p
        v-else-if="['F2'].includes(onboardingVariant)"
        class="tw-text-black tw-mb-4 tw-text-[20px] md:tw-text-2xl"
      >
        You won’t be charged today. If your doctor prescribes treatment after reviewing your intake, your card will be charged and your treatment will ship.
      </p>

      <p
        v-else
        class="sub-text tw-mb-4"
        :class="[
          ['F1', 'G'].includes(onboardingVariant)
            ? 'tw-border-black'
            : 'tw-text-[#787878]'
        ]"
      >
        Add a payment method to be used if treatment is prescribed (you will not be charged now).
      </p>
    </template>
    <template v-else>
      <p class="sub-text">
        Add a payment method to be used if treatment is prescribed (you will not
        be charged now).
        <!-- TODO: hide modal for billing information for now -->
        <br>
        <span
          style="color: #828282; cursor: pointer"
          class="text-underline"
          @click="openModal()"
        >
          Why do you need my credit card information?
        </span>
      </p>
    </template>
    
    <template v-if="onboardingVariant !== 'F2'">
      <div
        v-if="isOnboardingRedesign"
        class="text-underline tw-cursor-pointer tw-text-[#1A6A72] tw-mt-5 tw-mb-10"
        :class="{'tw-mb-20': ['F1', 'C', 'G'].includes(onboardingVariant)}"
        @click="openModal()"
      >
        Why do you need my credit card information?
      </div>
    </template>
    <template v-else>
      <div class="tw-mt-5 tw-mb-24"></div>
    </template>

    <b-card
      v-if="!nonrx && body.desiredplan"
      :style="isOnboardingRedesign ? '' : 'background-color: rgba(242, 242, 242, 0.5)'"
      :class="{'tw-border-[#C7C7C7] tw-rounded-lg tw-relative tw-max-w-[600px] tw-mx-auto': isOnboardingRedesign}"
    >
      <div
        v-if="isOnboardingRedesign && ['F1', 'F2', 'C', 'G'].includes(onboardingVariant)"
        class="tw-absolute tw-w-full tw-left-0 -tw-top-14 -tw-z-10 tw-right-0 tw-bg-[#1A6A72] tw-text-white tw-p-4 tw-rounded-lg tw-flex tw-gap-2 tw-items-center tw-pb-8 md:tw-justify-center"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.3231 19.2399C15.5368 19.2399 19.7634 15.0134 19.7634 9.79966C19.7634 4.58593 15.5368 0.359375 10.3231 0.359375C5.10937 0.359375 0.882813 4.58593 0.882813 9.79966C0.882813 15.0134 5.10937 19.2399 10.3231 19.2399ZM15.8171 7.34016C16.0827 7.07463 16.0827 6.64412 15.8171 6.37859C15.5516 6.11306 15.1211 6.11306 14.8556 6.37859L8.50611 12.728L6.66458 10.8865C6.39905 10.621 5.96854 10.621 5.70301 10.8865C5.43748 11.1521 5.43748 11.5826 5.70302 11.8481L8.02534 14.1704L8.50612 14.6512L8.9869 14.1704L15.8171 7.34016Z"
            fill="white"
          />
        </svg>
        HSA/FSA-eligible for reimbursement
      </div>
      <template v-if="isOnboardingRedesign">
        <h3
          v-if="['F1', 'F2', 'C', 'G'].includes(onboardingVariant)"
          class="tw-text-xl tw-mb-8"
        >
          Your Pending Prescriptions:
        </h3>
        <h3
          v-else
          class="tw-text-xl tw-mb-8"
        >
          Your Treatment If Prescribed
        </h3>
      </template>
      <template v-else>
        <h3 class="label-text mb-5">
          Your Treatment if Prescribed
        </h3>
      </template>
      <b-row
        v-for="med in body.desiredplan.filter(
          (x) =>
            x.type === undefined || (x.type != undefined && x.type === 'RX')
        )"
        :key="med.productid"
        align-v="center"
        style="margin-bottom: 1rem"
      >
        <b-col cols="8">
          <h4
            class="tw-text-xl mb-1"
            :class="isOnboardingRedesign ? 'tw-text-lg' : 'label-text'"
          >
            {{ med.name }}
          </h4>
          <span
            v-if="med.pricingdetail.nickname === 'Auto-refilled every 3 months'"
            class="small-text"
            :class="{'tw-text-[#787878]': isOnboardingRedesign}"
          >3 months supply</span>
          <span
            v-else-if="med.pricingdetail.nickname === 'Ships every 3 months'"
            class="small-text"
            :class="{'tw-text-[#787878]': isOnboardingRedesign}"
          >3 months supply</span>
          <span
            v-else-if="med.pricingdetail.nickname === 'Ships every month'"
            class="small-text"
            :class="{'tw-text-[#787878]': isOnboardingRedesign}"
          >1 month supply</span>
          <span
            v-else-if="med.pricingdetail.nickname === 'One time payment'"
            class="small-text"
            :class="{'tw-text-[#787878]': isOnboardingRedesign}"
          >per order</span>
          <span
            v-else
            class="small-text"
            :class="{'tw-text-[#787878]': isOnboardingRedesign}"
          >{{ med.pricingdetail.nickname }}</span>
        </b-col>
        <b-col
          cols="4"
          class="text-right"
        >
          <h3 :class="isOnboardingRedesign ? 'tw-text-xl' : 'label-text'">
            ${{ med.price }}
          </h3>
        </b-col>
      </b-row>
      <div class="mt-4"></div>
      <hr
        v-if="body.hasOwnProperty('referraldiscountamount') || discountDisplay"
      >
      <b-row
        v-if="body.referraldiscountamount"
        :class="{'tw-mb-4': isOnboardingRedesign}"
      >
        <b-col cols="8">
          <span v-if="isOnboardingRedesign">Referral Discount</span>
          <span
            v-else
            class="small-text"
          >First Time Referral Discount</span>
        </b-col>
        <b-col
          cols="4"
          class="text-right"
        >
          <span :class="{'small-text': !isOnboardingRedesign}"> -${{ body.referraldiscountamount }}</span>
        </b-col>
      </b-row>

      <template v-if="discount > 0 && !isOnboardingRedesign">
        <b-row>
          <b-col cols="8">
            <!-- WIN-8178 -->
            <h4 class="label-text mb-1">
              {{ body.couponid }}
            </h4>
            <span
              v-if="couponData.percent_off"
              class="small-text"
            >{{ couponData.percent_off }}% off<span
              v-if="couponData.duration == 'once'"
            >
              of your first purchase</span></span>
          </b-col>
          <b-col
            cols="4"
            class="text-right"
          >
            <span
              class="small-text text-info"
            >{{ couponData.percent_off }}% off</span>
            <span class="small-text"> -${{ discountDisplay }} </span>
          </b-col>
        </b-row>

        <hr
          class="my-3"
          style="border-color: #19191c"
        >
      </template>
      <div
        v-if="isOnboardingRedesign"
        class="tw-space-y-4"
      >
        <b-row v-if="discount > 0">
          <b-col cols="8">
            Promo Discount
          </b-col>
          <b-col
            cols="4"
            class="text-right"
          >
            -${{ discountDisplay }}
          </b-col>
        </b-row>
        <template v-if="onboardingVariant !== 'D1'">
          <b-row>
            <b-col cols="6">
              Medical Evaluation
            </b-col>
            <b-col
              cols="6"
              class="text-right"
            >
              <template v-if="['D2', 'E1', 'F3v1', 'F3v2', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant)">
                <span style="text-decoration: line-through">$50.00</span>&nbsp;Free
              </template>
              <span v-else>$0.00</span>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="8">
              24/7 Doctor Access & Ongoing Care
            </b-col>
            <b-col
              cols="4"
              class="text-right"
            >
              $0.00
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="8">
              Shipping
            </b-col>
            <b-col
              cols="4"
              class="text-right"
            >
              <span v-if="['D2', 'E1', 'F3v1', 'F3v2', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant)">Free</span>
              <span v-else>$0.00</span>
            </b-col>
          </b-row>

          <b-row>
            <template v-if="formacodeDiscount">
              <b-col cols="8">
                Giftcard Discount
              </b-col>

              <b-col class="text-right">
                -{{ toUsCurrency(formacodeDiscount) }}
              </b-col>
            </template>
          </b-row>
        </template>
      </div>
      <b-row>
        <template v-if="!isOnboardingRedesign || onboardingVariant === 'D1'">
          <b-col cols="8">
            <span :class="{'small-text': !isOnboardingRedesign}">Online doctor visit &amp; shipping</span>
          </b-col>

          <b-col class="text-right">
            <span
              :class="{'small-text': !isOnboardingRedesign}"
              style="text-decoration: line-through"
            >
              $50.00
            </span>

            <span :class="{'small-text': !isOnboardingRedesign}"> Free</span>
          </b-col>
        </template>

        <template v-if="formacodeDiscount">
          <b-col cols="8">
            Giftcard Discount
          </b-col>

          <b-col class="text-right">
            -{{ toUsCurrency(formacodeDiscount) }}
          </b-col>
        </template>
      </b-row>

      <hr>

      <b-row>
        <b-col cols="6">
          <span :class="{'tw-text-xl': isOnboardingRedesign}">Grand Total</span>
        </b-col>
        <b-col
          cols="6"
          class="text-right"
        >
          <span :class="{'tw-text-xl': isOnboardingRedesign}">{{ toUsCurrency(totalamount) }}</span>
        </b-col>
      </b-row>
    </b-card>

    <b-card
      v-if="0 && body.pharmacyid != ''"
      style="background-color: rgba(242, 242, 242, 0.5)"
    >
      <h3 class="mb-5 label-text">
        Platform Fee
      </h3>

      <b-row>
        <b-col
          cols="8"
        >
          <span
            class="small-text"
          >Outside Winona Pharmacy Network</span>
        </b-col>
        <b-col
          cols="4"
          class="text-right"
        >
          <span class="small-text">${{ platformfee.toFixed(2) }}</span>
        </b-col>
      </b-row>
    </b-card>

    <h3
      v-if="desiredAddon.length > 0"
      class="label-text mt-5 pt-2"
    >
      To Pay
    </h3>
    <b-card
      v-if="desiredAddon.length > 0"
      style="background-color: rgba(242, 242, 242, 0.5)"
    >
      <h3 class="mb-5 label-text">
        Your Order
      </h3>

      <hr class="my-3">

      <b-row>
        <b-col cols="8">
          Order Sub-total
        </b-col>
        <b-col
          cols="4"
          class="text-right"
        >
          ${{ subtotal.toFixed(2) }}
        </b-col>
      </b-row>
      <hr
        v-if="0 && body.pharmacyid != ''"
        class="my-3"
      >
      <b-row v-if="0 && body.pharmacyid != ''">
        <b-col cols="8">
          Platform fee
        </b-col>
        <b-col
          cols="4"
          class="text-right"
        >
          ${{ platformfee.toFixed(2) }}
        </b-col>
      </b-row>
      <hr class="my-3">
      <b-row>
        <b-col cols="8">
          Tax
        </b-col>
        <b-col
          cols="4"
          class="text-right"
        >
          ${{ taxamount.toFixed(2) }}
        </b-col>
      </b-row>

      <hr
        class="my-3"
        style="border-color: #19191c; border-width: 3px"
      >
      <b-row>
        <b-col cols="6">
          <b>Grand Total</b>
        </b-col>
        <b-col
          cols="6"
          class="text-right"
        >
          <b>${{ totalamount.toFixed(2) }}</b>
        </b-col>
      </b-row>
    </b-card>

    <div
      v-if="isShowPromoCodeForm && !hasAppliedFormaCode"
      class="promo-code-form"
    >
      <span class="promo-code-form__label"> Enter Giftcard </span>

      <div class="promo-code-form__body">
        <div class="promo-code-form__text-wrapper">
          <input
            v-model="formaCode.id"
            v-mask="FORMA_CODE.FORMAT"
            type="text"
            class=""
            :class="{
              'is-valid': formaCode.isValid,
              'is-invalid': formaCode.isValid === false,
            }"
            :disabled="hasAppliedFormaCode || formaCode.isLoading"
          >

          <IconLoading
            v-if="formaCode.isLoading"
            class="promo-code-form__loading-icon"
          />

          <span
            v-if="formaCode.isValid === false"
            class="promo-code-form__error-label"
          >
            Giftcard not valid
          </span>
        </div>

        <button
          :disabled="
            formaCode.id.length !== FORMA_CODE.FORMAT.length ||
              formaCode.isLoading
          "
          @click="applyCoupon"
        >
          Apply
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// libs
import _ from 'lodash';
import { mapState } from 'vuex';

// services
import { TransactionService } from '@/services/transaction.service';
import { OnboardingService } from '@/services/onboarding.service';

// components
import CreditModal from '@/components/partials/SideModal';
import IconLoading from '@/components/icon/IconLoading';

// utils
import $cookies from '@/utils/cookies';
import { toUsCurrency, toNumber } from '@/utils/number';

// constants
import { COOKIES, FORMA_CODE } from '@/constants';

// mixins
import analyticsMixin from '@/mixins/analytics';
import onboarding from '@/store/modules/onboarding';

export default {
  components: {
    CreditModal,
    IconLoading,
  },
  mixins: [analyticsMixin],
  props: {
    body: Object,
    nonrx: {
      type: Boolean,
      default: false,
    },
    discount: {
      type: Number,
      default: 0,
    },
    onboardingflow: {
      type: String,
      default: 'flowA',
    },
    analyticsId: {
      type: String,
      default: '',
    },
    getOnboarding: {
      type: Function,
      required: true,
    },
    billingSkipped: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      FORMA_CODE,
      formaCode: {
        id: '',
        isValid: null,
        isLoading: false,
      },
      total: 0,
      checkoutData: { checkout: [] },
      desiredAddon: [],
      desiredPlan: [],
      couponData: {},
      orderDetail: {},
      orderSummary: {},
      subtotal: 0,
      plantotal: 0,
      addontotal: 0,
      taxamount: 0,
      taxrate: 0,
      totalamount: 0,
      platformfee: 0, // 50.0,
      showModal: false,
    };
  },
  computed: {
    ...mapState('onboarding', ['onboardingPatient']),
    ...mapState('global', ['isOnboardingRedesign']),
    onboardingVariant() {
      return this.onboardingPatient?.flow_variant;
    },

    formacodeDiscount() {
      return toNumber(this.onboardingPatient?.formaCodeDiscountAmount);
    },

    hasAppliedFormaCode() {
      return !!this.onboardingPatient?.formaCodeDiscountApplied;
    },

    discountDisplay() {
      return (Math.round(this.discount * 100) / 100).toFixed(2);
    },

    isShowPromoCodeForm() {
      return !!$cookies.get(COOKIES.SHOW_PROMO_FORM.COOKIE_NAME);
    },
  },
  watch: {
    body() {
      this.calculateTreatmentPlans();
    },
  },
  async mounted() {
    window.scrollTo(0, 0);
    await this.$_analytics_track(
      'Onboarding Screen Viewed',
      {
        customerId: this.analyticsId,
        screen: '5.3-A',
        onboardingflow: this.onboardingflow,
        firstname: this.body.firstname,
        lastname: this.body.lastname,
      },
    );

    this.calculateTreatmentPlans();
  },
  methods: {
    _get: _.get,

    toUsCurrency,

    calculateTreatmentPlans() {
      this.checkoutData.checkout = [];
      if (this.body.formaCodeDiscountApplied) {
        this.formaCode.id = this.body.formaCodeDiscountApplied;
        this.formaCode.isValid = true;
      }
      if (this.body.desiredaddon) {
        for (const med of this.body.desiredaddon) {
          this.total = this.total + Math.floor(med.price);
          this.checkoutData.checkout.push({
            productid: med.productid,
            pricingid: med.pricingid,
            quantity: med.quantity,
          });
        }
      }
      // Desired Plan
      if (!this.nonrx && this.body.desiredplan && this.body.desiredplan.length > 0) {
        for (const med of this.body.desiredplan) {
          if (med.pricingdetail && med.pricingdetail.pricingid) {
            this.checkoutData.checkout.push({
              productid: med.productid,
              pricingid: med.pricingdetail.pricingid,
              quantity: med.quantity ? med.quantity : 1,
            });
          }
        }
      }
      this.computeTax();
    },

    openModal() {
      this.elementTag('hidden', true);
    },
    hideModal() {
      this.elementTag(null, false);
    },
    elementTag(style, Boolean) {
      this.showModal = Boolean;
      const htmlTag = document.documentElement;
      htmlTag.style.overflow = style;
      // htmlTag.scrollTop = htmlTag.scrollHeight;
    },
    async applyCoupon() {
      try {
        this.formaCode.isLoading = true;

        if (_.isEmpty(this.formaCode.id)) {
          this.formaCode.isValid = null;
          return;
        }

        await OnboardingService.applyCoupon({
          couponid: this.formaCode.id,
        });

        await this.getOnboarding();

        this.computeTax();

        this.formaCode.isValid = true;
      } catch (error) {
        this.formaCode.isValid = false;
      } finally {
        this.formaCode.isLoading = false;
      }
    },

    async computeTax() {
      try {
        const { referraldiscountamount, couponid } = this.body;

        const creditDiscount =
          this.formacodeDiscount + toNumber(referraldiscountamount);

        this.checkoutData.creditdiscount = creditDiscount;
        this.checkoutData.couponid = couponid;

        if (couponid) {
          const couponGet = await OnboardingService.checkCoupon(couponid);

          this.couponData = couponGet.data;
        }

        const res = await TransactionService.computeTax(this.checkoutData);

        if (res && res.data) {
          const { orderdetail, ordersummary } = res.data;
          this.orderSummary = ordersummary;
          this.taxamount = ordersummary.taxamount;
          this.totalamount = ordersummary.totalamount;

          if (ordersummary.discount > 0) {
            this.$emit('set-discount', ordersummary.discount);
          }

          return this.$emit('set-total', this.totalamount);
        }

        const addon = [];
        const desired = [];

        this.desiredAddon = addon;
        this.desiredPlan = desired;

        if (
          !this.nonrx &&
          this.body.desiredplan &&
          this.body.desiredplan.length > 0
        ) {
          const desiredplan = this.body.desiredplan.filter(x => {
            return (
              x.type === undefined || (x.type != undefined && x.type === 'RX')
            );
          });

          for (const record of desiredplan) {
            this.plantotal += Number(record.price);
          }
        }

        if (this.body.desiredaddon && this.body.desiredaddon.length > 0) {
          for (const record of this.body.desiredaddon) {
            this.addontotal += Number(record.price);
          }
        }

        this.subtotal = this.addontotal + this.plantotal || 0;
        this.totalamount =
          this.subtotal + this.taxamount + this.platformfee || 0;
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style lang="scss">
.security-row {
  @include media-breakpoint-down(xs) {
    margin-top: 1.5rem !important;
    padding-top: 0 !important;
  }
}

.id-modal {
  background-color: #f6f6f6;
  // height: 45vh;

  // @include media-breakpoint-down(xs) {
  //   height: 30vh;
  // }

  img {
    height: 50%;
  }
}

.id-body-modal {
  overflow: auto;
  // height: 55vh !important;
  overflow-x: hidden;

  @include media-breakpoint-down(xs) {
    // height: 70vh !important;
  }
}

.promo-code-form {
  display: flex;
  margin-bottom: 1.5rem;
  align-items: center;
  gap: 1.5rem;

  &__label {
    flex-shrink: 0;
  }

  &__text-wrapper {
    flex-grow: 1;
    position: relative;

    input {
      width: 100%;
      height: 100%;
      background-color: transparent;
      outline: none;
      border: none;
      border-bottom: 1px solid black;

      &.is-valid {
        border-bottom: 1px solid #22c55e;
      }

      &.is-invalid {
        border-bottom: 1px solid #ef4444;
      }
    }
  }

  &__error-label {
    position: absolute;
    left: 0;
    bottom: -18px;
    color: #ef4444;
    font-size: 12px;
  }

  &__loading-icon {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
  }

  &__body {
    border: 1px solid #edf2f9;
    background-color: rgba(242, 242, 242, 0.5);
    padding: 1rem;
    width: 100%;
    position: relative;
    display: flex;
    gap: 5px;

    button {
      background-color: #a783ff;
      border: 1px solid #a783ff;
      border-radius: 4px;
      color: white;
      cursor: pointer;
      font-family: arial, sans-serif;
      font-size: 14px;
      height: 36px;
      line-height: 27px;
      padding: 0 16px;
      text-align: center;
      user-select: none;
      -webkit-user-select: none;
      touch-action: manipulation;
      white-space: pre;
      &:disabled {
        opacity: 0.8;
        cursor: not-allowed;
      }
    }
  }
}
</style>
